import { useState, useEffect } from 'react';

export const usePyodide = () => {
  const [pyodide, setPyodide] = useState<any>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadPyodide = async () => {

      try {
        const pyodideInstance = await (window as any).loadPyodide({
          indexURL: "https://cdn.jsdelivr.net/pyodide/v0.25.1/full/",
        });

        await pyodideInstance.loadPackage("numpy");
        
        const response = await fetch("/lenia_numpy_fft.py");
        const scriptText = await response.text();
        await pyodideInstance.runPythonAsync(scriptText);
        
        setPyodide(pyodideInstance);
        setIsLoaded(true);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load Pyodide');
      }
    };

    loadPyodide();
  }, []);

  return { pyodide, isLoaded, error };
};